export const TESTID_IFRAME = 'IFRAME';
export const TESTID_WRAPPER = 'WRAPPER';
export const TESTID_WRAPPER_CONTAINER = 'WRAPPER_CONTAINER';
export const TESTID_RECONNECT_WALLET = 'RECONNECT_WALLET';
export const TESTID_IFRAME_CLOSE_BTN = 'TESTID_IFRAME_CLOSE_BTN';
export const IFRAME_ID = 'CIVIC_PASS_IFRAME';
export const RC_FLOW_ID_PREFIX = 'GWRC';
